// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/f7d2757b/" + chunkId + "." + __webpack_require__.h() + ".vf7d2757b.js";
};